import type { FeedbackMessages } from './en';

const fr: FeedbackMessages = {
  qualified: {
    title: 'Merci d’avoir participé à cette étude !',
    body1: 'Vous pouvez maintenant fermer cette fenêtre de navigateur.',
    body2: 'Nous espérons vous revoir bientôt.',
    refCode: 'Code de référence : {code}',
  },
  quotaFull: {
    title: 'Cette étude est close',
    body1: 'Merci de l’intérêt que vous portez à notre étude.',
    body2: 'Malheureusement, nous avons déjà reçu toutes les réponses dont nous avions besoin.',
    body3: 'Nous espérons vous revoir dans une de nos futures études !',
    refCode: 'Code de référence : {code}',
  },
  terminated: {
    title: 'Merci pour votre retour !',
    body1:
      'Nous espérons vous revoir bientôt lors de nos futures études. En attendant, nous vous souhaitons une excellente journée.',
    body2: 'Merci de fermer cette fenêtre de navigateur.',
    refCode: 'Code de référence : {code}',
  },
  mismatch: {
    title: 'Merci de votre intérêt',
    body1: 'Malheureusement, vous ne faites pas partie du groupe cible de cette étude spécifique.',
    body2: 'Vous pouvez fermer cette page.',
    code: 'Code : {code}',
  },
  error: {
    title: 'Nous ne sommes pas en mesure de traiter votre demande',
    linkProblemDetailed:
      'Le lien que vous avez suivi présente un problème. Veuillez vérifier que le lien affiché dans la barre d’adresse correspond bien à celui qui vous a été communiqué, puis réessayez.',
    linkProblemGeneric:
      'Le lien que vous avez suivi présente un problème. Veuillez réessayer.',
    contactPerson:
      'Si le problème persiste, veuillez en informer la personne qui vous a communiqué ce lien.',
    errorCode: 'Code d’erreur : {code}',
  },
};

export default fr;
